export const locales = ['en', 'us', 'de', 'fr', 'sv'];

export function setupTranslation(translations) {
    const translationsObj = [];
    for (let i = 0; i < translations.length; i++) {
        translationsObj[translations[i].locale] = {
            ...translations[i],
        };
    }

    if (translationsObj.length < locales.length) {
        for (let i = 0; i < locales.length; i++) {
            if (!translationsObj[locales[i]]) {
                translationsObj[locales[i]] = {};
            }
        }
    }

    return translationsObj;
}
